/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ToolsService } from 'src/app/services/tools.service';
import { MinimizeIconComponent } from 'src/chatbot/icons/minimize-icon.component';
import { FullScreenIconComponent } from 'src/chatbot/icons/full-screen-icon.component';
import { NormalScreenIconComponent } from 'src/chatbot/icons/normal-screen-icon.component';
import { DataChatService } from 'src/chatbot/service/dataChat.service';
import { ModalController } from '@ionic/angular';
import { ChatBotInfoComponent } from '../chatBotInfo/chatBotInfo.component';
import { SendMailComponent } from '../sendMail/sendMail.component';
import { ReloadIconComponent } from 'src/chatbot/icons/reload-icon.component';
import { WebSocketService } from 'src/chatbot/service/webSocket.service';
import { StatisticsService } from 'src/app/services/statistics.service';
import { v4 as uuidv4 } from "uuid";
import { StepsNavigationMapService } from 'src/app/pages/custom-route/shared/map/services/steps-navigation.service';
import dayjs from "dayjs";
import { CustomRouteService } from 'src/app/pages/custom-route/services';

@Component({
  selector: 'chat-header',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MinimizeIconComponent,
    FullScreenIconComponent,
    NormalScreenIconComponent,
    ReloadIconComponent,
  ],
  templateUrl: './chatHeader.component.html',
  styleUrl: './chatHeader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatHeaderComponent {
    private _stepsNavigationMapService = inject(StepsNavigationMapService);
    private _customRouteService = inject(CustomRouteService);

    private statisticsService = inject(StatisticsService)
    private webSocketService = inject(WebSocketService)
    public toolsService = inject(ToolsService)
    public dataChatService = inject(DataChatService);
    public logoSrc = computed(() => this.dataChatService.icon())
    public chatName = computed(() => this.dataChatService.name())
    public isFullScreen = computed(() => this.dataChatService.isFullScreen())
    public hasSaveChat = computed(() => this.dataChatService.hasSaveChat())
    public canSaveChat = computed(() => this.dataChatService.canSaveChat())
    public isNew = computed(() => this.dataChatService.isNew());

    private modalController = inject(ModalController)
    private modal: any;

    toggleView(){
        this.dataChatService.hideChat.update(prev => !prev);
        if (this.dataChatService.hideChat()) 
          this.dataChatService.isFullScreen.set(false)
    }

    
      private setWelcomePayload(route){
        return route?.dailyRoutes?.map((day, index) => {
          return {
            day: index,
            saturedItems: day.points?.map(point => {
              if (point.relateds && point.relatedsItems?.length > 0){
                const relateds = point.relatedsItems?.map(relatedPoint => ({
                  id: relatedPoint.id,
                  name: relatedPoint.name?.['es'],
                  type: relatedPoint.type
                }))
    
                return {
                  id: point.id,
                  name: point.title,
                  type: point.type,
                  startDate: dayjs(point.startDate).format('YYYY-MM-DDTHH:mm'),
                  endDate: dayjs(point.endDate).format('YYYY-MM-DDTHH:mm'),
                  relateds
                }
              }
              return null;
            })?.filter(point => point)
          }
        })
      }

    resetChat(){      
      this.webSocketService.disconnect();
      this.webSocketService.historyChat = [];
      const newToken = uuidv4(); //this.statisticsService.generateNewSessionId();
      this.dataChatService.token.set(newToken);
      this.dataChatService.messages.set([])
      this.dataChatService.requestIsFulliled.set(false);
      this.webSocketService.connectAll();
        // this.dataChatService.resetChat();
    }

    toggleFullScreen(){
      this.dataChatService.isFullScreen.update(prev => !prev);
    }

    toggleAction(action){
      switch(action){
        case 'email': 
          if (!this.canSaveChat()) return;
          this.openModal(SendMailComponent); 
          break;
        case 'info': this.openModal(ChatBotInfoComponent); break;
      }
    }

    async openModal(component) {
      if (this.modal) return;
      this.modal = await this.modalController.create({
        component: component,
        cssClass: "chatBotModal",
        componentProps: {},
      });
      await this.modal.present();
      await this.modal.onDidDismiss();
      this.modal = null;
    }


}